import axios from "axios";

export const sendWhatsAppMessage = async (
  userPhoneNumber: string,
  pdfUrl: string
) => {
  const accessToken = process.env.REACT_APP_WHATSAPP_API_KEY;
  const phoneNumberId = process.env.REACT_APP_PHONE_ID;

  const formattedPhoneNumber =
    userPhoneNumber?.startsWith("91") || userPhoneNumber?.startsWith("+91")
      ? userPhoneNumber.replace(/^\+/, "")
      : `91${userPhoneNumber}`;

  const payload = {
    messaging_product: "whatsapp",
    to: formattedPhoneNumber,
    type: "template",
    template: {
      name: "quotation_pi",
      language: {
        code: "en",
      },
      components: [
        {
          type: "header",
          parameters: [
            {
              type: "document",
              document: {
                link: pdfUrl,
                filename: "Quotation_PI.pdf",
              },
            },
          ],
        },
      ],
    },
  };
  try {
    const response = await axios.post(
      `https://graph.facebook.com/v22.0/${phoneNumberId}/messages`,

      payload,

      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
  } catch (error) {
    console.error("WhatsApp Message Error:", error);
  }
};
